var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaylist = function SvgPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.75 8a1 1 0 0 1 1-1h24a1 1 0 1 1 0 2h-24a1 1 0 0 1-1-1Zm0 5.333a1 1 0 0 1 1-1h24a1 1 0 0 1 0 2h-24a1 1 0 0 1-1-1Zm0 5.334a1 1 0 0 1 1-1h10.667a1 1 0 0 1 0 2H4.75a1 1 0 0 1-1-1Zm0 5.333a1 1 0 0 1 1-1h10.667a1 1 0 0 1 0 2H4.75a1 1 0 0 1-1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.917 18.825c2.205 1.273 3.307 1.91 3.47 2.828.04.23.04.465 0 .694-.163.919-1.265 1.555-3.47 2.828-2.205 1.274-3.308 1.91-4.184 1.591a2 2 0 0 1-.602-.347c-.714-.6-.714-1.873-.714-4.419 0-2.546 0-3.82.714-4.419.179-.15.382-.267.602-.347.876-.319 1.979.317 4.184 1.59Z"
  })));
};
export default SvgPlaylist;